/**
 * Used to show parallax effect in heros. Does NOT work if used for sections below the hero
 */

function parallaxScroll() {
    const scrollDistance = window.scrollY || window.pageYOffset;
    const container = document.querySelector('.js-parallax');
    const opacityGroup = document.querySelectorAll('.js-parallax__opacity');
    const translateGroup = document.querySelectorAll('.js-parallax__translate');

    if (!container) return;


    // Check if .js-parallax has the .js-no-mobile-parallax class
    if (container) {
        const disableParallaxMobile = container.classList.contains('js-no-mobile-parallax');
        console.log('Parallax disabled on mobile:', disableParallaxMobile);
    }

    // Check if the device supports touch events and has a small screen width
    const isMobile =
        ('ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0) &&
        window.innerWidth < 768;

    // If the device is not mobile, apply parallax effects
    if (!(isMobile && disableParallaxMobile)) {
        // To Do: Add Modernizr
        // if (!Modernizr.touch) {
        // Alter opacity
        opacityGroup.forEach(function (element) {
            element.style.opacity = 1 - scrollDistance / 500;
        });

        // Alter scrolling speed
        translateGroup.forEach(function (element) {
            element.style.transform = `translate3d(0px, ${
                0.2 * scrollDistance
            }px, 0px)`;
        });
        // }
    }
}

// You can call parallaxScroll() whenever necessary to apply the parallax effect.
module.exports = parallaxScroll;
